import { IStyle } from 'Styles';
import { ButtonsListContainer } from 'components/Button';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { CustomCheckBox, FormInputRow } from 'components/input';
import { IOption } from 'components/input/selectInput';
import React, { useEffect, useMemo, useState } from 'react';
import { useScoreGroupDetailsGroup, useScoreGroupDetailsScore } from 'redux/hooks/common';
import { useSelectedScores, useSetSelectedScores } from 'redux/hooks/searchnFilter';
import { removeItemIfFoundElsePush } from 'utils/Global';

interface Props {
  hideModal: () => void;
}

export default function ScreenHitScoreSelectionModal(props: Props) {
  const { hideModal } = props;
  const wellDropGroup = useScoreGroupDetailsGroup();
  const wellDropScore: any = useScoreGroupDetailsScore();
  const setSelectedScores = useSetSelectedScores();
  const [selectedWellDropGroupId, setSelectedWellDropGroupId] = useState<number>(1);
  const selectedScores = useSelectedScores(selectedWellDropGroupId);
  const [selectedScoreslist, setSelectedChecklist] = useState<number[]>(
    selectedScores || [],
  );

  const actionButtons: RMCustomButtonProps[] = [
    {
      title: 'CANCEL',
      contentContainerClass: 'bg-[#F7A246] w-[9.5rem] !text-[#ffffff] h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => {
        hideModal();
      },
    },
    {
      title: 'CONFIRM',
      contentContainerClass: 'btn-outline-yellow-wide h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => {
        if (selectedScoreslist.length > 0) {
          setSelectedScores({ [selectedWellDropGroupId]: selectedScoreslist });
        }
        hideModal();
      },
    },
  ];

  const wellGroupOptionsList: IOption[] = useMemo(() => {
    return wellDropGroup.map((item) => ({ title: item.name, value: item.scoreGroupsId }));
  }, [wellDropGroup]);

  const onCheckboxSelectionChange = (item, i) => {
    setSelectedChecklist((prevArray) => {
      const newArray = [...prevArray];
      removeItemIfFoundElsePush(newArray, item.wellDropScoreId);
      return newArray;
    });
  };

  useEffect(() => {
    setSelectedChecklist(selectedScores || []);
  }, [selectedWellDropGroupId]);

  return (
    <div id="screenhitscoreselectionmodal-main-container">
      <FormInputRow
        id="screenhitscoreselectionmodal-form-input-row"
        labeltext="Select Score Group"
        containerClassname="w-full"
        containerStyle={{ display: 'flow' }}
        labelClassname="text-black w-full h-[15px]"
        inputType="select"
        inputClassname="rounded-sm border-2 border-gray-300 h-[30px] self-stretch"
        inputContainerClass="w-full"
        options={wellGroupOptionsList}
        value={selectedWellDropGroupId}
        onChange={(e) => {
          setSelectedWellDropGroupId(parseInt(e.target.value));
        }}
      />

      <div id="screenhitscoreselectionmodal-select-scores">
        <label id="screenhitscoreselectionmodal-select-scores-label-text">
          Select Scores
        </label>
        <div
          id="screenhitscoreselectionmodal-select-scores-well-drop-wrapper"
          className="border-2 border-gray-300 border-solid rounded-md h-80 overflow-y-auto p-1"
        >
          {wellDropScore &&
            wellDropScore[selectedWellDropGroupId]?.map((val, i) => (
              <CustomCheckBox
                id={`screenhitscoreselectionmodal-select-scores-well-drop-checkbox-${i}`}
                onChange={(e) => {
                  onCheckboxSelectionChange(val, i);
                }}
                key={'WellScore' + i}
                label={val.scoreName}
                checked={selectedScoreslist.includes(val.wellDropScoreId)}
                mainContainerStyle={styles.checkbox}
                labelStyle={styles.labelStyle}
                disabled={false}
              />
            ))}
        </div>
      </div>
      <ButtonsListContainer
        containerStyleClass="my-3 justify-end"
        marginBetweenItems={4}
        buttonsList={actionButtons}
      />
    </div>
  );
}

const styles: IStyle = {
  checkbox: {
    marginBottom: 8,
  },
  labelStyle: {
    fontWeight: 400,
    fontSize: '1rem',
    color: '#4F4F4F',
    marginLeft: '0.75rem',
  },
};
